import { ProjectDataPerimetro } from '../../entities/project-data-perimetro.entity';
import * as THREE from 'three';
import { ConfigService } from 'src/app/app.config';
import { UtilsBuilder } from '../utils-builder';
import { Satelite3dComponent } from './satelite3d.component';

export class GestorSatelite3d {

	// Margenes de altura y longitud desde el centro.
	//private readonly Margen LAT = 0.000516678; // 115
	private MargenLAT = 1; // 115
	private readonly MargenLNG = 0.000687418; // 115
	//private readonly Margen LAT2 = this.Margen LAT * 2;
	//private readonly Margen LAT2 = 2;
	private readonly MargenLNG2 = this.MargenLNG * 2;

	private SizeTilde = 116; // Barcelona, se ajusta en el contructor.

	// División de la matriz o matrices.
	private readonly MatrixDiv = 18;

	private readonly RAD90 = 1.5707963267948966;

	// Mapas que componen el escenario.
	private _maps = [];
	public get maps() { return this._maps; }

	private elevations = [];			// Elevaciones devueltas por Google.
	public elevationsMax = 0;			// Elevación más alta.
	private checkElevations = 0;		// Cantidad de bloques de 324 elevaciones (18*18).

	private wall: THREE.PlaneBufferGeometry;
	private wallMesh: THREE.Mesh;
	private wallMaterial: THREE.MeshBasicMaterial;

	//private __ajuste = 0.000263;

	//#region Types de mosaicos.
	private Types = [
		{	// |_|			1x1
			tipo: 'L1C1', lines: 1, columns: 1, //check Map: 1,
			divH: 18, divV: 18, checkElevations: 1, blocksElevations: 324, jump: 18,
			mapas: [
				{
					lat: 0, lng: 0, x: 0, y: 0, z: 0, pointer: 0,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				}
			], wallDivision: 68,
			walls: [
				{ cantidad: 17, mapa: 0, mainMapa: 0, stepMapa: 18 }
				, { cantidad: 17, mapa: 0, mainMapa: 306, stepMapa: 1 }
				, { cantidad: 17, mapa: 0, mainMapa: 323, stepMapa: -18 }
				, { cantidad: 18, mapa: 0, mainMapa: 17, stepMapa: -1 }
			]
		},
		{	// |_|_|		1x2
			tipo: 'L1C2', lines: 1, columns: 2, //check Map: 2,
			divH: 35, divV: 18, checkElevations: 2, blocksElevations: 315, jump: 35,
			mapas: [
				{
					//la t: 0, lng: -this.MargenLNG, check: 0, x: -57.5, y: 0, z: 0, pointer: 0,
					lat: 0, lng: -this.MargenLNG, check: 0, x: -0.5, y: 0, z: 0, pointer: 0,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				},
				{
					//la t: 0, lng: this.MargenLNG, check: 0, x: 57.5, y: 0, z: 0, pointer: 17,
					lat: 0, lng: this.MargenLNG, check: 0, x: 0.5, y: 0, z: 0, pointer: 17,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				}
			], wallDivision: 102,
			walls: [
				{ cantidad: 17, mapa: 0, mainMapa: 0, stepMapa: 18 },
				{ cantidad: 17, mapa: 0, mainMapa: 306, stepMapa: 1 },
				{ cantidad: 17, mapa: 1, mainMapa: 306, stepMapa: 1 },
				{ cantidad: 17, mapa: 1, mainMapa: 323, stepMapa: -18 },
				{ cantidad: 17, mapa: 1, mainMapa: 17, stepMapa: -1 },
				{ cantidad: 18, mapa: 0, mainMapa: 17, stepMapa: -1 }
			]
		},
		{	// |_|_|_|		1x3
			tipo: 'L1C3', lines: 1, columns: 3, //check Map: 3,
			divH: 53, divV: 18, checkElevations: 3, blocksElevations: 318, jump: 53,
			mapas: [
				{
					//la t: 0, lng: -this.MargenLNG2, check: 0, x: -115, y: 0, z: 0, pointer: 0,
					lat: 0, lng: -this.MargenLNG2, check: 0, x: -1, y: 0, z: 0, pointer: 0,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				},
				{
					lat: 0, lng: 0, check: 0, x: 0, y: 0, z: 0, pointer: 17,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				},
				{
					//la t: 0, lng: this.MargenLNG2, check: 0, x: 115, y: 0, z: 0, pointer: 34,
					lat: 0, lng: this.MargenLNG2, check: 0, x: 1, y: 0, z: 0, pointer: 34,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				}
			], wallDivision: 136,
			walls: [
				{ cantidad: 17, mapa: 0, mainMapa: 0, stepMapa: 18 },
				{ cantidad: 17, mapa: 0, mainMapa: 306, stepMapa: 1 },
				{ cantidad: 17, mapa: 1, mainMapa: 306, stepMapa: 1 },
				{ cantidad: 17, mapa: 2, mainMapa: 306, stepMapa: 1 },
				{ cantidad: 17, mapa: 2, mainMapa: 323, stepMapa: -18 },
				{ cantidad: 17, mapa: 2, mainMapa: 17, stepMapa: -1 },
				{ cantidad: 17, mapa: 1, mainMapa: 17, stepMapa: -1 },
				{ cantidad: 18, mapa: 0, mainMapa: 17, stepMapa: -1 }
			]
		},
		{	// |_|			2x1
			// |_|
			// FIXME Imagenes equivicadas se desplazan abajo y arriba.
			tipo: 'L2C1', lines: 2, columns: 1, //check Map: 2,
			divH: 18, divV: 35, checkElevations: 2, blocksElevations: 315, jump: 18,
			mapas: [
				{
					//la t: this.Margen LAT, lng: 0, check: 0, x: 0, y: 0, z: -0.5, pointer: 0,
					lat: 1, lng: 0, check: 0, x: 0, y: 0, z: -0.5, pointer: 0,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				},
				{
					//la t: -this.Margen LAT, lng: 0, check: 0, x: 0, y: 0, z: 0.5, pointer: 306,
					lat: -1, lng: 0, check: 0, x: 0, y: 0, z: 0.5, pointer: 306,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				}
			], wallDivision: 102,
			walls: [
				{ cantidad: 17, mapa: 0, mainMapa: 0, stepMapa: 18 },
				{ cantidad: 17, mapa: 1, mainMapa: 0, stepMapa: 18 },
				{ cantidad: 17, mapa: 1, mainMapa: 306, stepMapa: 1 },
				{ cantidad: 17, mapa: 1, mainMapa: 323, stepMapa: -18 },
				{ cantidad: 17, mapa: 0, mainMapa: 323, stepMapa: -18 },
				{ cantidad: 18, mapa: 0, mainMapa: 17, stepMapa: -1 }
			]
		},
		{	// |_|_|		2x2
			// |_|_|
			// FIXME Imagenes equivicadas se desplazan abajo y arriba.
			tipo: 'L2C2', lines: 2, columns: 2, //check Map: 5,
			divH: 35, divV: 35, checkElevations: 5, blocksElevations: 245, jump: 35,
			mapas: [
				{
					lat: 1, lng: -this.MargenLNG, check: 0, x: -0.5, y: 0, z: -0.5, pointer: 0,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				},
				{
					lat: 1, lng: this.MargenLNG, check: 0, x: 0.5, y: 0, z: -0.5, pointer: 17,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				},
				{
					lat: -1, lng: -this.MargenLNG, check: 0, x: -0.5, y: 0, z: 0.5, pointer: 595,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				},
				{
					lat: -1, lng: this.MargenLNG, check: 0, x: 0.5, y: 0, z: 0.5, pointer: 612,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				}
			], wallDivision: 136,
			walls: [
				{ cantidad: 17, mapa: 0, mainMapa: 0, stepMapa: 18 },
				{ cantidad: 17, mapa: 2, mainMapa: 0, stepMapa: 18 },
				{ cantidad: 17, mapa: 2, mainMapa: 306, stepMapa: 1 },
				{ cantidad: 17, mapa: 3, mainMapa: 306, stepMapa: 1 },
				{ cantidad: 17, mapa: 3, mainMapa: 323, stepMapa: -18 },
				{ cantidad: 17, mapa: 1, mainMapa: 323, stepMapa: -18 },
				{ cantidad: 17, mapa: 1, mainMapa: 17, stepMapa: -1 },
				{ cantidad: 18, mapa: 0, mainMapa: 17, stepMapa: -1 }
			]
		},
		{	// |_|_|_|
			// |_|_|_|
			// FIXME Imagenes equivicadas se desplazan abajo y arriba.
			tipo: 'L2C3', lines: 2, columns: 3, //check Map: 5,
			divH: 53, divV: 35, checkElevations: 5, blocksElevations: 371, jump: 53,
			mapas: [
				{
					lat: 1, lng: -this.MargenLNG2, check: 0, x: -1, y: 0, z: -0.5, pointer: 0,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				},
				{
					lat: 1, lng: 0, check: 0, x: 0, y: 0, z: -0.5, pointer: 17,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				},
				{
					lat: 1, lng: this.MargenLNG2, check: 0, x: 1, y: 0, z: -0.5, pointer: 34,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				},
				{
					lat: -1, lng: -this.MargenLNG2, check: 0, x: -1, y: 0, z: 0.5, pointer: 901,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				},
				{
					lat: -1, lng: 0, check: 0, x: 0, y: 0, z: 0.5, pointer: 918,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				},
				{
					lat: -1, lng: this.MargenLNG2, check: 0, x: 1, y: 0, z: 0.5, pointer: 935,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				}
			], wallDivision: 170,
			walls: [
				{ cantidad: 17, mapa: 0, mainMapa: 0, stepMapa: 18 },
				{ cantidad: 17, mapa: 3, mainMapa: 0, stepMapa: 18 },
				{ cantidad: 17, mapa: 3, mainMapa: 306, stepMapa: 1 },
				{ cantidad: 17, mapa: 4, mainMapa: 306, stepMapa: 1 },
				{ cantidad: 17, mapa: 5, mainMapa: 306, stepMapa: 1 },
				{ cantidad: 17, mapa: 5, mainMapa: 323, stepMapa: -18 },
				{ cantidad: 17, mapa: 2, mainMapa: 323, stepMapa: -18 },
				{ cantidad: 17, mapa: 2, mainMapa: 17, stepMapa: -1 },
				{ cantidad: 17, mapa: 1, mainMapa: 17, stepMapa: -1 },
				{ cantidad: 18, mapa: 0, mainMapa: 17, stepMapa: -1 }
			]
		},
		{	// |_|			3x1
			// |_|
			// |_|
			// FIXME Imagenes equivicadas se desplazan abajo y arriba.
			tipo: 'L3C1', lines: 3, columns: 1, //check Map: 3,
			divH: 18, divV: 52, checkElevations: 3, blocksElevations: 312, jump: 18,
			mapas: [
				{
					//la t: this.Margen LAT2, lng: 0, check: 0, x: 0, y: 0, z: -115, pointer: 0,
					lat: 2, lng: 0, check: 0, x: 0, y: 0, z: -1, pointer: 0,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				},
				{
					lat: 0, lng: 0, check: 0, x: 0, y: 0, z: 0, pointer: 306,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				},
				{
					//la t: -this.Margen LAT2, lng: 0, check: 0, x: 0, y: 0, z: 115, pointer: 612,
					lat: -2, lng: 0, check: 0, x: 0, y: 0, z: 1, pointer: 612,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				}
			], wallDivision: 136,
			walls: [
				{ cantidad: 17, mapa: 0, mainMapa: 0, stepMapa: 18 },
				{ cantidad: 17, mapa: 1, mainMapa: 0, stepMapa: 18 },
				{ cantidad: 17, mapa: 2, mainMapa: 0, stepMapa: 18 },
				{ cantidad: 17, mapa: 2, mainMapa: 306, stepMapa: 1 },
				{ cantidad: 17, mapa: 2, mainMapa: 323, stepMapa: -18 },
				{ cantidad: 17, mapa: 1, mainMapa: 323, stepMapa: -18 },
				{ cantidad: 17, mapa: 0, mainMapa: 323, stepMapa: -18 },
				{ cantidad: 18, mapa: 0, mainMapa: 17, stepMapa: -1 }
			]
		},
		{	// |_|_|		3x2
			// |_|_|
			// |_|_|
			// FIXME Imagenes equivicadas se desplazan abajo y arriba.
			tipo: 'L3C2', lines: 3, columns: 2, //check Map: 5,
			divH: 35, divV: 52, checkElevations: 5, blocksElevations: 364, jump: 35,
			mapas: [
				{
					//la t: this.Margen LAT2, lng: -this.MargenLNG, check: 0, x: -57.5, y: 0, z: -115, pointer: 0,
					lat: 2, lng: -this.MargenLNG, check: 0, x: -0.5, y: 0, z: -1, pointer: 0,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				},
				{
					//la t: this.Margen LAT2, lng: this.MargenLNG, check: 0, x: 57.5, y: 0, z: -115, pointer: 17,
					lat: 2, lng: this.MargenLNG, check: 0, x: 0.5, y: 0, z: -1, pointer: 17,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				},
				{
					//la t: 0, lng: -this.MargenLNG, check: 0, x: -57.5, y: 0, z: 0, pointer: 595,
					lat: 0, lng: -this.MargenLNG, check: 0, x: -0.5, y: 0, z: 0, pointer: 595,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				},
				{
					//la t: 0, lng: this.MargenLNG, check: 0, x: 57.5, y: 0, z: 0, pointer: 612,
					lat: 0, lng: this.MargenLNG, check: 0, x: 0.5, y: 0, z: 0, pointer: 612,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				},
				{
					//la t: -this.Margen LAT2, lng: -this.MargenLNG, check: 0, x: -57.5, y: 0, z: 115, pointer: 1190,
					lat: -2, lng: -this.MargenLNG, check: 0, x: -0.5, y: 0, z: 1, pointer: 1190,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				},
				{
					//la t: -this.Margen LAT2, lng: this.MargenLNG, check: 0, x: 57.5, y: 0, z: 115, pointer: 1207,
					lat: -2, lng: this.MargenLNG, check: 0, x: 0.5, y: 0, z: 1, pointer: 1207,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				}
			], wallDivision: 170,
			walls: [
				{ cantidad: 17, mapa: 0, mainMapa: 0, stepMapa: 18 },
				{ cantidad: 17, mapa: 2, mainMapa: 0, stepMapa: 18 },
				{ cantidad: 17, mapa: 4, mainMapa: 0, stepMapa: 18 },
				{ cantidad: 17, mapa: 4, mainMapa: 306, stepMapa: 1 },
				{ cantidad: 17, mapa: 5, mainMapa: 306, stepMapa: 1 },
				{ cantidad: 17, mapa: 5, mainMapa: 323, stepMapa: -18 },
				{ cantidad: 17, mapa: 3, mainMapa: 323, stepMapa: -18 },
				{ cantidad: 17, mapa: 1, mainMapa: 323, stepMapa: -18 },
				{ cantidad: 17, mapa: 1, mainMapa: 17, stepMapa: -1 },
				{ cantidad: 18, mapa: 0, mainMapa: 17, stepMapa: -1 }
			]
		},
		{	// |_|_|_|		3x3
			// |_|_|_|
			// |_|_|_|
			tipo: 'L3C3', lines: 3, columns: 3, //check Map: 8,
			divH: 52, divV: 52, checkElevations: 8, blocksElevations: 338, jump: 52,
			mapas: [
				{
					//la t: this.Margen LAT2, lng: -this.MargenLNG2, check: 0, x: -115, y: 0, z: -115, pointer: 0,
					lat: 2, lng: -this.MargenLNG2, check: 0, x: -1, y: 0, z: -1, pointer: 0,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				},
				{
					//la t: this.Margen LAT2, lng: 0, check: 0, x: 0, y: 0, z: -115, pointer: 17,
					lat: 2, lng: 0, check: 0, x: 0, y: 0, z: -1, pointer: 17,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				},
				{
					//la t: this.Margen LAT2, lng: this.MargenLNG2, check: 0, x: 115, y: 0, z: -115, pointer: 34,
					lat: 2, lng: this.MargenLNG2, check: 0, x: 1, y: 0, z: -1, pointer: 34,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				},
				{
					//la t: 0, lng: -this.MargenLNG2, check: 0, x: -115, y: 0, z: 0, pointer: 884,
					lat: 0, lng: -this.MargenLNG2, check: 0, x: -1, y: 0, z: 0, pointer: 884,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				},
				{
					lat: 0, lng: 0, check: 0, x: 0, y: 0, z: 0, pointer: 901,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				},
				{
					//la t: 0, lng: this.MargenLNG2, check: 0, x: 115, y: 0, z: 0, pointer: 918,
					lat: 0, lng: this.MargenLNG2, check: 0, x: 1, y: 0, z: 0, pointer: 918,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				},
				{
					//la t: -this.Margen LAT2, lng: -this.MargenLNG2, check: 0, x: -115, y: 0, z: 115, pointer: 1768,
					lat: -2, lng: -this.MargenLNG2, check: 0, x: -1, y: 0, z: 1, pointer: 1768,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				},
				{
					//la t: -this.Margen LAT2, lng: 0, check: 0, x: 0, y: 0, z: 115, pointer: 1785,
					lat: -2, lng: 0, check: 0, x: 0, y: 0, z: 1, pointer: 1785,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				},
				{
					//la t: -this.Margen LAT2, lng: this.MargenLNG2, check: 0, x: 115, y: 0, z: 115, pointer: 1802,
					lat: -2, lng: this.MargenLNG2, check: 0, x: 1, y: 0, z: 1, pointer: 1802,
					mat: THREE.MeshBasicMaterial, buffer: THREE.PlaneGeometry, mesh: THREE.Mesh
				}
			], wallDivision: 204,
			walls: [
				{ cantidad: 17, mapa: 0, mainMapa: 0, stepMapa: 18 },
				{ cantidad: 17, mapa: 3, mainMapa: 0, stepMapa: 18 },
				{ cantidad: 17, mapa: 6, mainMapa: 0, stepMapa: 18 },
				{ cantidad: 17, mapa: 6, mainMapa: 306, stepMapa: 1 },
				{ cantidad: 17, mapa: 7, mainMapa: 306, stepMapa: 1 },
				{ cantidad: 17, mapa: 8, mainMapa: 306, stepMapa: 1 },
				{ cantidad: 17, mapa: 8, mainMapa: 323, stepMapa: -18 },
				{ cantidad: 17, mapa: 5, mainMapa: 323, stepMapa: -18 },
				{ cantidad: 17, mapa: 2, mainMapa: 323, stepMapa: -18 },
				{ cantidad: 17, mapa: 2, mainMapa: 17, stepMapa: -1 },
				{ cantidad: 17, mapa: 1, mainMapa: 17, stepMapa: -1 },
				{ cantidad: 18, mapa: 0, mainMapa: 17, stepMapa: -1 }
			]
		}
	];
	//#endregion

	public typeMosaic: any;

	// Máximos en altura y longitud permitidos por tilde, si se sobrepasa se debe crear otra tilde.
	//private readonly SizeTildeMax = this.Size Tilde - 10;

	// Centro de todo el mosaico.
	public centerZone: { x: 0, y: 0, z: 0, elevation: 0 }; // ?

	private _lat = 0;
	private _lng = 0;
	public get lng() { return this._lng; }
	public get lat() { return this._lat; }
	//public limitsZone = {};

	private _lines = 0;
	private _columns = 0;
	public get lines() { return this._lines; }
	public get columns() { return this._columns; }

	// Centros de los perímetros.
	//private centers: { x: 0, y: 0, z: 0, la t: 0, lng: 0, elevation: 0 }[];

	// Todos los perímetros que componen el proyecto.
	private perimeters = [];

	// Zona general con todos los perímetros.
	public zone: google.maps.LatLngBounds;

	// Objeto 3D que representa el root en la escena.
	private _root: THREE.Object3D;

	private _canDraw = false;
	public get canDraw() { return this._canDraw; }

	private s3dComp:Satelite3dComponent;

	// ##############################################################
	// ##### El constructor requiere el array de perímetros que tiene el proyecto.
	constructor(perimeters: ProjectDataPerimetro[], root: THREE.Object3D, s3dComp?:Satelite3dComponent, loadGoogleData = true) {
		// Crear la zona de trabajo.
		this.zone = new google.maps.LatLngBounds();

		if(s3dComp){
			this.s3dComp = s3dComp;
		}

		this._root = root;

		// Recorrer todos los perímetros insertando sus posiciones.
		for (let perimeter of perimeters) {
			this.insertPerimeter(perimeter);
		}

		// Actualizar latLng de la zona de trabajo.
		let l = this.zone.getCenter();
		this._lat = l.lat();
		this._lng = l.lng();

		//##################################
		this.SizeTilde = Math.trunc(155 * (Math.cos(this.lat * Math.PI / 180) * 1));
		//this.MargenLAT = 0.000686 - ((155 - this.SizeTilde) * (0.0002/45));
		//if (this.SizeTilde >= 153) this.MargenLAT = 0.0006865; // 0 - 15 grados.
		//else if (this.SizeTilde >= 148) this.MargenLAT = 0.0006755435; // 15 - 25 grados.
		//else if (this.SizeTilde >= 140) this.MargenLAT = 0.0006455; // 25 - 35 grados.
		//else if (this.SizeTilde >= 126) this.MargenLAT = 0.000595; // 35 - 45 grados.
		//else if (this.SizeTilde >= 115) this.MargenLAT = 0.000525799; // 45 - 55 grados.
		//else if (this.SizeTilde >= 88) this.MargenLAT = 0.000442; // 55 - 65 grados.
		//else this.MargenLAT = 0.000344; // 75 grados

		this.MargenLAT = 0.0006865 - ((154 - this.SizeTilde) * 0.000004457792207792208);
		//this.MargenLAT = 0.0006865 - ((155 - this.SizeTilde) * 0.0000043759);
		//console.log('>>>> SizeTilde::' + this.SizeTilde + '; LAT::' + this.lat);
		//##################################

		// Calcular frontera principal, zone.
		this.calculateZone();

		// Crear el mosaico de tildes.
		if(loadGoogleData) {
			this.createMosaic();
		}
	}

	public releaseResources()
	{
		if( this._root ) {
			this._root = null;
		}

		if( this.zone ) {
			this.zone = null;
		}

		if( this.wall ) {
			this.wall = null;
		}

		if( this.wallMesh ) {
			this.wall = null;
		}

		if( this.wallMaterial ) {
			this.wallMaterial = null;
		}

		if( this.perimeters ) {
			this.perimeters = null;
		}

		if( this._maps ) {
			this._maps = null;
		}

		if( this.elevations ) {
			this.elevations = null;
		}
	}

	// ##### Inserta un perímetro.
	public insertPerimeter(perimeter: ProjectDataPerimetro) {
		// El perímetro debe existir y debe contener como mínimo dos coordenadas.
		if (!perimeter.coordenadas || perimeter.coordenadas.length < 2) return;

		// Insertar los puntos.
		let dots = [];
		for (let coor of perimeter.coordenadas) {
			// Obtener coordenadas X,Y,Z de latLong.
			let v = UtilsBuilder.latLngToVector3d(coor.dots[0].lat, coor.dots[0].lng);
			let p = { x: v.x, y: v.y, z: v.z, lat: coor.dots[0].lat, lng: coor.dots[0].lng, elevation: 0 };
			// Inserta en la zona de trabajo los puntos.
			this.zone.extend({ lat: p.lat, lng: p.lng });
			// Se almacena la información en su correspodiente perímetro.
			dots.push(p);
		}
		this.perimeters.push(dots);
	}

	// ##### Calcula la suma de todos los perímetros para obtener la zona de trabajo.
	// ##### Partiendo de aquí, toma la decisión de cuantas tildes hacen falta.
	public calculateZone() {
		let bounds = this.zone.toJSON();
		let heightReal = google.maps.geometry.spherical.computeDistanceBetween(
			new google.maps.LatLng(bounds.south, bounds.west),
			new google.maps.LatLng(bounds.north, bounds.west)
		);
		let widthReal = google.maps.geometry.spherical.computeDistanceBetween(
			new google.maps.LatLng(bounds.north, bounds.west),
			new google.maps.LatLng(bounds.north, bounds.east)
		);

		// Analizar que mosaico necesita.
		const sizeTildeMax = this.SizeTilde - 10;
		this._lines = 1;
		if (heightReal > sizeTildeMax) {
			this._lines++;
			if (heightReal > (this.SizeTilde + sizeTildeMax)) {
				this._lines++;
			}
		}
		this._columns = 1;
		if (widthReal > sizeTildeMax) {
			this._columns++;
			if (widthReal > (this.SizeTilde + sizeTildeMax)) {
				this._columns++;
			}
		}

		let aux = this.Types.filter(t => { return t.lines == this._lines && t.columns == this._columns });
		// this.typeMosaic = this.Types.filter(t => { return t.lines == this._lines && t.columns == this._columns });

		if (aux.length > 0) {
			this.typeMosaic = aux[0];

			//###############################################
			// ORDENAR CENTROS.
			if (this.typeMosaic.mapas.length > 1) {
				//this.MargenLAT = (686 - ((150 - this.SizeTilde) * (200/42))) / 1000000;
				//console.log('this.MargenLAT::' + this.MargenLAT);
				for (let i = 0; i < this.typeMosaic.mapas.length; i++) {
					this.typeMosaic.mapas[i].x *= this.SizeTilde;
					this.typeMosaic.mapas[i].z *= this.SizeTilde;
					this.typeMosaic.mapas[i].lat *= this.MargenLAT;
				}
			}
			//###############################################
		}
	}

	// ##### Crea el mosaico, llama a las imagenes de Google y sus elevaciones.
	public createMosaic(): boolean {
		//return;
		// La zona debe contener algún punto.
		if (this.zone.isEmpty()) return false;
		// Debe existir un tipo de mosaico.
		if (!this.typeMosaic) return;

		// Actualizar los centros de las tildes.
		for (let index = 0; index < this.typeMosaic.mapas.length; index++) {
			this.typeMosaic.mapas[index].lat += this._lat;
			this.typeMosaic.mapas[index].lng += this._lng;
		}

		// Obtener todos los puntos latlng en un array.

		let limitNorth = this._lat + (this.typeMosaic.lines * this.MargenLAT); // depende del tipo 1x2 ...
		let limitWest = this._lng - (this.typeMosaic.columns * this.MargenLNG);
		let limitSouth = this._lat - (this.typeMosaic.lines * this.MargenLAT);
		let limitEast = this._lng + (this.typeMosaic.columns * this.MargenLNG);

		let inicioV = limitNorth; // north
		let inicioH = limitWest; // west

		//let divH = (this.MatrixDiv * this.typeMosaic.columns);
		let h = (limitEast - limitWest) / this.typeMosaic.divH; // Obtener la división lng.
		//let divV = (this.MatrixDiv * this.typeMosaic.lines);
		let v = (limitNorth - limitSouth) / this.typeMosaic.divV; // Obtener la división lat.

		// Crear las arrays horizontal (lng) y vertical (lat).
		let limitsLat = [inicioV]; // El primero.
		let limitsLng = [inicioH]; // El primero.
		for (let i = 1; i < this.typeMosaic.divH; i++) {
			inicioH += h;
			limitsLng.push(inicioH);
		}
		for (let i = 1; i < this.typeMosaic.divV; i++) {
			inicioV -= v;
			limitsLat.push(inicioV);
		}
		limitsLat.push(limitSouth); // El último.
		limitsLng.push(limitEast); // El último.

		// Crear la matrix con las coordenadas latLng.
		let coor = [];
		for (let iLat = 0; iLat < this.typeMosaic.divV; iLat++) {			// LNG
			for (let iLng = 0; iLng < this.typeMosaic.divH; iLng++) {		// LAT
				coor.push({ lat: limitsLat[iLat], lng: limitsLng[iLng] });
			}
		}
		this.elevations = [];
		this.elevationsMax = 0;
		this.checkElevations = this.typeMosaic.checkElevations;

		let init = 0;
		for (let blocks = 0; blocks < this.typeMosaic.checkElevations; blocks++) {
			this.getElevatiosByPlane2(coor.slice(init, init + this.typeMosaic.blocksElevations), init);
			init += this.typeMosaic.blocksElevations;
		}
		return true;
	}

	// ##### Crea el mosaico, llama a las imagenes de Google y sus elevaciones.
	public async createMosaicAsync(): Promise<boolean> {
		//return;
		// La zona debe contener algún punto.
		if (this.zone.isEmpty()) return false;
		// Debe existir un tipo de mosaico.
		if (!this.typeMosaic) return;

		// Actualizar los centros de las tildes.
		for (let index = 0; index < this.typeMosaic.mapas.length; index++) {
			this.typeMosaic.mapas[index].lat += this._lat;
			this.typeMosaic.mapas[index].lng += this._lng;
		}

		// Obtener todos los puntos latlng en un array.

		let limitNorth = this._lat + (this.typeMosaic.lines * this.MargenLAT); // depende del tipo 1x2 ...
		let limitWest = this._lng - (this.typeMosaic.columns * this.MargenLNG);
		let limitSouth = this._lat - (this.typeMosaic.lines * this.MargenLAT);
		let limitEast = this._lng + (this.typeMosaic.columns * this.MargenLNG);

		let inicioV = limitNorth; // north
		let inicioH = limitWest; // west

		//let divH = (this.MatrixDiv * this.typeMosaic.columns);
		let h = (limitEast - limitWest) / this.typeMosaic.divH; // Obtener la división lng.
		//let divV = (this.MatrixDiv * this.typeMosaic.lines);
		let v = (limitNorth - limitSouth) / this.typeMosaic.divV; // Obtener la división lat.

		// Crear las arrays horizontal (lng) y vertical (lat).
		let limitsLat = [inicioV]; // El primero.
		let limitsLng = [inicioH]; // El primero.
		for (let i = 1; i < this.typeMosaic.divH; i++) {
			inicioH += h;
			limitsLng.push(inicioH);
		}
		for (let i = 1; i < this.typeMosaic.divV; i++) {
			inicioV -= v;
			limitsLat.push(inicioV);
		}
		limitsLat.push(limitSouth); // El último.
		limitsLng.push(limitEast); // El último.

		// Crear la matrix con las coordenadas latLng.
		let coor = [];
		for (let iLat = 0; iLat < this.typeMosaic.divV; iLat++) {			// LNG
			for (let iLng = 0; iLng < this.typeMosaic.divH; iLng++) {		// LAT
				coor.push({ lat: limitsLat[iLat], lng: limitsLng[iLng] });
			}
		}
		this.elevations = [];
		this.elevationsMax = 0;
		this.checkElevations = this.typeMosaic.checkElevations;

		let init = 0;
		for (let blocks = 0; blocks < this.typeMosaic.checkElevations; blocks++) {
			await this.getElevatiosByPlane2(coor.slice(init, init + this.typeMosaic.blocksElevations), init);
			init += this.typeMosaic.blocksElevations;
		}
		return true;
	}

	public meshesMap = [];
	private async getElevatiosByPlane2(coor: any[], init: number) {
		let elevator = new google.maps.ElevationService();
		const reqPoint: google.maps.LocationElevationRequest = { locations: coor }

		let  Promises = [];
		const promise = new Promise((resolve, reject) => {
				elevator.getElevationForLocations({ 'locations': coor },
				(results, status) => {
					switch (status) {
						case google.maps.ElevationStatus.OK:
							for (let ele of results) {
								this.elevations[init] = ele.elevation;
								if (ele.elevation > this.elevationsMax) this.elevationsMax = ele.elevation;
								init++;
							}

							this.checkElevations--;

							if (this.checkElevations == 0) {

								for (let line = 0; line < this.typeMosaic.lines; line++) {
									for (let column = 0; column < this.typeMosaic.columns; column++) {
										// Crear tilde.
										let idTilde = (line * this.typeMosaic.columns) + column;
										let tilde = this.typeMosaic.mapas[idTilde];

										tilde.geometry = new THREE.PlaneBufferGeometry(this.SizeTilde, this.SizeTilde, this.MatrixDiv - 1, this.MatrixDiv - 1);
										tilde.mat = new THREE.MeshBasicMaterial({ color: 0xbbbbbb }); //, side: THREE.DoubleSide });

										tilde.mesh = new THREE.Mesh(tilde.geometry, tilde.mat);
										tilde.mesh.name = "Suelo_" + idTilde;

										this._maps.push(tilde);

										this.meshesMap.push(tilde.mesh);

										let p = tilde.geometry.attributes.position;

										let indexMatrix = 0;
										for (let l = 0; l < 18; l++) {
											// Situarse en la línea.
											let puntero = tilde.pointer + (this.typeMosaic.jump * l);
											for (let c = 0; c < 18; c++) {
												p.setZ(indexMatrix, this.elevations[puntero]);
												puntero++;
												indexMatrix++;
											}
										}

										tilde.mesh.position.set(tilde.x, -this.elevationsMax, tilde.z);
										tilde.mesh.rotation.x = -this.RAD90;

										tilde.mesh.updateMatrixWorld(true);
										this._root.add(tilde.mesh);

										tilde.geometry.computeVertexNormals();

										this.getImageMap(this.typeMosaic, idTilde);
									}
								}
								// Crear las cuator parades de la superficie para que no se vea el interior.
								this.makeWall();

								this._canDraw = true; // Indicar que ya se puede dibujar los objetos 3D.
								// ESPRRIVISA-132
								resolve(true);
								break;
							}
							// ESPRRIVISA-132
							resolve(true);
							break;

						case google.maps.ElevationStatus.INVALID_REQUEST:
							console.error('GetorDatas3D:: Elevaciones google maps INALID REQUEST');
							reject(false);
							break;
						case google.maps.ElevationStatus.OVER_QUERY_LIMIT:
							setTimeout(() => { this.getElevatiosByPlane2(coor, init) }, 500);
							reject(false);
							break;
						case google.maps.ElevationStatus.REQUEST_DENIED:
							console.error('GetorDatas3D:: Elevaciones google maps DENIED');
							reject(false);
							break;
						case google.maps.ElevationStatus.UNKNOWN_ERROR:
							console.error('GetorDatas3D:: Elevaciones google maps UNKNOWN ERROR');
							reject(false);
							break;
					}
				});
			});
		Promises.push(promise);

		const array = await Promise.all(Promises);
	}
	// private getElevatiosByPlane2(coor: any[], init: number) {
	// 	let elevator = new google.maps.ElevationService();
	// 	elevator.getElevationForLocations({ 'locations': coor },
	// 		(results, status) => {
	// 			switch (status) {
	// 				case google.maps.ElevationStatus.OK:
	// 					for (let ele of results) {
	// 						this.elevations[init] = ele.elevation;
	// 						if (ele.elevation > this.elevationsMax) this.elevationsMax = ele.elevation;
	// 						init++;
	// 					}

	// 					//this.typeMosaic.chec kMap--;
	// 					this.checkElevations--;

	// 					if (this.checkElevations == 0) {

	// 						for (let line = 0; line < this.typeMosaic.lines; line++) {
	// 							for (let column = 0; column < this.typeMosaic.columns; column++) {
	// 								// Crear tilde.
	// 								let idTilde = (line * this.typeMosaic.columns) + column;
	// 								let tilde = this.typeMosaic.mapas[idTilde];

	// 								tilde.geometry = new THREE.PlaneBufferGeometry(this.SizeTilde, this.SizeTilde, this.MatrixDiv - 1, this.MatrixDiv - 1);
	// 								tilde.mat = new THREE.MeshBasicMaterial({ color: 0xbbbbbb }); //, side: THREE.DoubleSide });

	// 								tilde.mesh = new THREE.Mesh(tilde.geometry, tilde.mat);
	// 								tilde.mesh.name = "Suelo_" + idTilde;
	// 								this._maps.push(tilde);

	// 								this.meshesMap.push(tilde.mesh);

	// 								let p = tilde.geometry.attributes.position;

	// 								let indexMatrix = 0;
	// 								for (let l = 0; l < 18; l++) {
	// 									// Situarse en la línea.
	// 									let puntero = tilde.pointer + (this.typeMosaic.jump * l);
	// 									for (let c = 0; c < 18; c++) {
	// 										p.setZ(indexMatrix, this.elevations[puntero]);
	// 										puntero++;
	// 										indexMatrix++;
	// 									}
	// 								}

	// 								tilde.mesh.position.set(tilde.x, -this.elevationsMax, tilde.z);
	// 								tilde.mesh.rotation.x = -this.RAD90;
	// 								this._root.add(tilde.mesh);

	// 								tilde.geometry.computeVertexNormals();

	// 								this.getImageMap(this.typeMosaic, idTilde);
	// 							}
	// 						}
	// 						// Crear las cuator parades de la superficie para que no se vea el interior.
	// 						this.makeWall();

	// 						this._canDraw = true; // Indicar que ya se puede dibujar los objetos 3D.
	// 					}
	// 					return;

	// 				case google.maps.ElevationStatus.INVALID_REQUEST:
	// 					console.error('GetorDatas3D:: Elevaciones google maps INALID REQUEST');
	// 					break;
	// 				case google.maps.ElevationStatus.OVER_QUERY_LIMIT:
	// 					setTimeout(() => { this.getElevatiosByPlane2(coor, init) }, 500);
	// 					break;
	// 				case google.maps.ElevationStatus.REQUEST_DENIED:
	// 					console.error('GetorDatas3D:: Elevaciones google maps DENIED');
	// 					break;
	// 				case google.maps.ElevationStatus.UNKNOWN_ERROR:
	// 					console.error('GetorDatas3D:: Elevaciones google maps UNKNOWN ERROR');
	// 					break;
	// 			}
	// 		});
	// }



	private makeWall() {
		this.wall = new THREE.PlaneBufferGeometry(16, 16, this.typeMosaic.wallDivision, 1);
		this.wallMaterial = new THREE.MeshBasicMaterial({ color: 0x000000 }); //, side: THREE.DoubleSide });
		this.wallMesh = new THREE.Mesh(this.wall, this.wallMaterial);

		this.wallMesh.position.set(0, -(this.elevationsMax), 0);
		this.wallMesh.rotation.x = -this.RAD90;

		// Array con los punteros
		let wallPoints = this.wall.attributes.position;

		// Indice para moverse por los vertices superiores.
		let puntero = 0;
		// Indice para moverse por los vertices inferiores.
		let puntero2 = this.typeMosaic.wallDivision + 1;

		// Recorrer todos los bucles.
		for (let mp of this.typeMosaic.walls) {
			// Adquirir el array de vertices del mapa.
			let map = this.meshesMap[mp.mapa];
			let x = map.position.x;
			let y = map.position.z;
			let points = map.geometry.attributes.position;

			// Inicio para unir.
			let iMapa = mp.mainMapa;
			for (let i = 0; i < mp.cantidad; i++) {
				wallPoints.setX(puntero, points.getX(iMapa) + x);
				wallPoints.setY(puntero, points.getY(iMapa) - y);
				wallPoints.setZ(puntero, points.getZ(iMapa));

				wallPoints.setX(puntero2, points.getX(iMapa) + x);
				wallPoints.setY(puntero2, points.getY(iMapa) - y);
				wallPoints.setZ(puntero2, 0);

				puntero++;				// Siguiente vertice superior.
				puntero2++;				// Siguiente vertice inferior.
				iMapa += mp.stepMapa;	// Salto al siguiente punto.
			}
		}

		this.wall.computeVertexNormals();

		this._root.add(this.wallMesh);
	}

	private getImageMap(tipo: any, index: number) {
		let _map = tipo.mapas[index];
		let url = "https://maps.googleapis.com/maps/api/staticmap?center=" + _map.lat + "," + _map.lng;
		url += "&zoom=19";
		url += "&size=512x512";
		url += "&scale=4";
		url += "&maptype=satellite";
		url += "&key=" + ConfigService.GOOGLE_API_KEY;
		//console.log(url);
		let loader = new THREE.TextureLoader();
		loader.load(
			url,
			(image) => {
				_map.mat.setValues({ map: image });
				_map.mat.needsUpdate = true;

				// console.log('Cargada textura googlemap');
				setTimeout(()=>{
					if(this.s3dComp){
						this.s3dComp.skipRender = true;
					}
				},100);
			},
			undefined,
			(error) => { console.log(error); }
		);
	}

}
